import React from "react"
import ThreeBlockIconTextGrid from "./3blockIconTextGrid"
import FourBlockIconTextGrid from "./4blockIconTextGrid"
import Accordion from "./accordion"
import AnimatedQuestionBlock from "./animatedQuestionBlock"
import AwardsBlock from "./awardsBlock"
import BoldContentBlock from "./boldContentBlock"
import ComparisonScreenSlideshow from "./comparisonScreenSlideshow"
import CtaBlock from "./ctaBlock"
import CtaI2 from "./ctaI2"
import CtaI3 from "./ctaI3"
import CustomerVideo from "./customerVideo"
import FormContent from "./formContent"
import FeatureSetBlock from "./featureSetBlock"
import FeaturedItemsBlock from "./featuredItemsBlock"
import HeroUpdated from "./heroUpdated"
import InteractivePlatformModule from "./interactivePlatformModule"
import InstagramFeed from "./instagramFeed"
import JobBoard from "./jobBoard"
import MediaContent from "./mediaContent"
import MediaContentAdvanced from "./mediaContentAdvanced"
import NewsBlock from "./newsBlock"
import SpacerBlock from "./spacerBlock"
import ParallaxDocumentsBlock from "./parallaxDocumentsBlock"
import PeopleModule from "./peopleModule"
import RelatedContentBlock from "./relatedContentBlock"
import SocialProofBlock from "./socialProofBlock"
import SocialProofBlockLinks from "./socialProofBlockLinks"
import SummitAgendaBlock from "./summitAgendaBlock"
import SummitSpeakersBlock from "./summitSpeakersBlock"
import TestimonialsBlock from "./testimonialsBlock"
import TextGridBlock from "./textGridBlock"
import TitleContentBlocksGrid from "./titleContentBlocksGrid"

import AboutClient from "./aboutClient"
import ContentPhoto from "./contentPhoto"
import PullQuote from "./pullQuote"
import RelatedCaseStudies from "./relatedCaseStudies"

const Modules = ({ modules }) => (
  <>
    {modules.map((module) => {
      switch(module['strapi_component']) {
        case "modules.3-bl-ico-w-txt-grid-content" : return (
          <ThreeBlockIconTextGrid
            key={ `${module['strapi_component']}-${module.id}` }
            image={module.image}
            imageLink={module.imageLink}
            heading={module.heading}
            content={module.content}
            iconWithTextBlockSetup={module.iconWithTextBlockSetup}
            ctaButtonText={module.ctaButtonText}
            ctaButtonLink={module.ctaButtonLink}
            iconTextBlocks={module.iconTextBlocks}
          />
        )
        case "modules.4-bl-ico-w-txt-grid-content" : return (
          <FourBlockIconTextGrid
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            content={module.content}
            blocksPosition={module.blocksPosition}
            ctaButtonText={module.ctaButtonText}
            ctaButtonLink={module.ctaButtonLink}
            iconTextBlocks={module.iconTextBlocks}
          />
        )
        case "modules.accordion" : return (
          <Accordion
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            content={module.content}
            link={module.link}
            accordionPanels={module.accordionPanels}
          />
        )
        case "modules.animated-question-block" : return (
          <AnimatedQuestionBlock
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            content={module.content}
            buttonText={module.buttonText}
            buttonLink={module.buttonLink}
            openNewTab={module.openNewTab}
            questionSlides={module.questionSlides}
          />
        )
        case "modules.awards-block" : return (
          <AwardsBlock
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            subText={module.subText}
            backgroundColor={module.backgroundColor}
            grayscale={module.grayscale}
            showTitle={module.showTitle}
            showDescription={module.showDescription}
          />
        )
        case "modules.bold-content-block" : return (
          <BoldContentBlock
            key={ `${module['strapi_component']}-${module.id}` }
            content={module.content}
          />
        )
        case "modules.comparison-screen-slideshow" : return (
          <ComparisonScreenSlideshow
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            content={module.content}
            comparisonSlides={module.comparisonSlides}
          />
        )
        case "modules.cta-block" : return (
          <CtaBlock
            key={ `${module['strapi_component']}-${module.id}` }
            useGlobalDefaultCta={module.useGlobalDefaultCta}
            heading={module.heading}
            content={module.content}
            link={module.link}
            linkText={module.linkText}
            background={module.background}
            backgroundImage={module.backgroundImage}
          />
        )
        case "modules.cta-block-i2" : return (
          <CtaI2
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            solidBackgroundColor={module.solidBackgroundColor}
            buttonText={module.buttonText}
            buttonLink={module.buttonLink}
            buttonOpenNewTab={module.buttonOpenNewTab}
            sellingPoints={module.sellingPoints}
            bottomHeading={module.bottomHeading}
            buttomButtonText={module.buttomButtonText}
            bottomButtonLink={module.bottomButtonLink}
            bottomButtonOpenNewTab={module.bottomButtonOpenNewTab}
          />
        )
        case "modules.cta-block-i3" : return (
          <CtaI3
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            content={module.content}
            solidBackgroundColor={module.solidBackgroundColor}
            link={module.link}
            linkText={module.linkText}
          />
        )
        case "modules.customer-video" : return (
          <CustomerVideo
            key={ `${module['strapi_component']}-${module.id}` }
            spotlights={module.customer_spotlights}
            testimonials={module.testimonials}
          />
        )
        case "modules.feature-set-block" : return (
          <FeatureSetBlock
            key={ `${module['strapi_component']}-${module.id}` }
            icon={module.icon}
            title={module.title}
            content={module.content}
            button={module.button}
            backgroundColor={module.backgroundColor}
            features={module.features}
          />
        )
        case "modules.featured-items-block" : return (
          <FeaturedItemsBlock
            key={ `${module['strapi_component']}-${module.id}` }
            title={module.title}
            subText={module.subText}
          />
        )
        case "modules.form-with-content" : return (
          <FormContent
            key={ `${module['strapi_component']}-${module.id}` }
            formPosition={module.formPosition}
            formTitle={module.formTitle}
            form={module.form}
            title={module.title}
            containsVideo={module.containsVideo}
            content={module.content}
            video={module.video}
          />
        )
        case "modules.hero-updated" : return (
          <HeroUpdated
            key={ `${module['strapi_component']}-${module.id}` }
            backgroundImageOrVideo={module.backgroundImageOrVideo}
            heading={module.heading}
            content={module.content}
            calloutImages={module.calloutImages}
            button={module.button}
            backgroundImage={module.backgroundImage}
          />
        )
        case "modules.interactive-platform-module" : return (
          <InteractivePlatformModule
            key={ `${module['strapi_component']}-${module.id}` }
            sectionTitle={module.sectionTitle}
            sectionContent={module.sectionContent}
            buckets={module.buckets}
            tabSections={module.tabSections}
          />
        )
        case "modules.instagram-feed" : return (
          <InstagramFeed
            key={ `${module['strapi_component']}-${module.id}` }
          />
        )
        case "modules.job-board" : return (
            <JobBoard
              key={ `${module['strapi_component']}-${module.id}` }
              heading={module.heading}
              content={module.content}
            />
          )
        case "modules.media-with-content-block" : return (
          <MediaContent
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            content={module.content}
            mediaPosition={module.mediaPosition}
            mediaPositionVertical={module.mediaPositionVertical}
            pattern={module.pattern}
            type={module.type}
            imageLink={module.imageLink}
            image={module.image}
            imageList={module.imageList}
            buttons={module.buttons}
            video={module.video}
          />
        )
        case "modules.media-with-content-advanced" : return (
          <MediaContentAdvanced
            key={ `${module['strapi_component']}-${module.id}` }
            type={module.type}
            heading={module.heading}
            content={module.content}
            mediaPosition={module.mediaPosition}
            imageLink={module.imageLink}
            openNewTab={module.openNewTab}
            image={module.image}
            imageList={module.imageList}
            buttons={module.buttons}
            video={module.video}
          />
        )
        case "modules.module-spacer-block" : return (
          <SpacerBlock
            key={ `${module['strapi_component']}-${module.id}` }
            spacerHeight={module.spacerHeight}
          />
        )
        case "modules.news-block" : return (
          <NewsBlock
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            subText={module.subText}
            backgroundColor={module.backgroundColor}
            grayscale={module.grayscale}
            showTitle={module.showTitle}
            showDescription={module.showDescription}
          />
        )
        case "modules.parallax-documents-block" : return (
          <ParallaxDocumentsBlock
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.Heading}
            content={module.content}
            button={module.button}
            document1={module.document1}
            document2={module.document2}
          />
        )
        case "modules.people-module" : return (
          <PeopleModule
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            backgroundColor={module.backgroundColor}
            caption={module.caption}
            people={module.people}
          />
        )
        case "modules.related-content-block" : return (
          <RelatedContentBlock
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            subText={module.subText}
            resources={module.resources}
            posts={module.posts}
          />
        )
        case "modules.social-proof-block" : return (
          <SocialProofBlock
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            subText={module.subText}
            backgroundColor={module.backgroundColor}
            grayscale={module.grayscale}
            logos={module.logos}
            buttons={module.buttons}
          />
        )
        case "modules.social-proof-block-with-links" : return (
          <SocialProofBlockLinks
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            subText={module.subText}
            backgroundColor={module.backgroundColor}
            grayscale={module.grayscale}
            logos={module.logos}
            buttons={module.buttons}
          />
        )
        case "modules.summit-agenda-block" : return (
          <SummitAgendaBlock
            key={ `${module['strapi_component']}-${module.id}` }
            summitDayBreakdown={module.summitDayBreakdown}
          />
        )
        case "modules.summit-speakers-block" : return (
          <SummitSpeakersBlock
            key={ `${module['strapi_component']}-${module.id}` }
            title={module.title}
            subTitle={module.subTitle}
            speakers={module.speakers}
          />
        )
        case "modules.testimonials-block" : return (
          <TestimonialsBlock
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            link={module.link}
            linkText={module.linkText}
            spotlights={module.customer_spotlights}
            testimonials={module.testimonials}
          />
        )
        case "modules.text-grid-block" : return (
          <TextGridBlock
            key={ `${module['strapi_component']}-${module.id}` }
            title={module.title}
            content={module.content}
            items={module.items}
            horizontalTitleAlignment={module.horizontalTitleAlignment}
            titleColor={module.titleColor}
            type={module.type}
          />
        )
        case "modules.title-with-content-blocks-grid" : return (
          <TitleContentBlocksGrid
            key={ `${module['strapi_component']}-${module.id}` }
            heading={module.heading}
            contentBlocks={module.contentBlocks}
          />
        )
        case "case-study-modules.about-client" : return (
          <AboutClient
            key={ `${module['strapi_component']}-${module.id}` }
            aboutClientTitle={module.aboutClientTitle}
            aboutClientContent={module.aboutClientContent}
            clientMission={module.clientMission}
            clientVision={module.clientVision}
            clientWebsiteUrl={module.clientWebsiteUrl}
            openNewTab={module.openNewTab}
            clientLogo={module.clientLogo}
          />
        )
        case "case-study-modules.content-with-photo" : return (
          <ContentPhoto
            key={ `${module['strapi_component']}-${module.id}` }
            blockTitle={module.blockTitle}
            blockContent={module.blockContent}
            mediaPosition={module.mediaPosition}
            icon={module.icon}
            photo={module.photo}
          />
        )
        case "case-study-modules.pull-quote" : return (
          <PullQuote
            key={ `${module['strapi_component']}-${module.id}` }
            quoteContent={module.quoteContent}
            name={module.name}
            jobTitle={module.jobTitle}
            photo={module.photo}
          />
        )
        case "case-study-modules.related-case-studies" : return (
          <RelatedCaseStudies
            key={ `${module['strapi_component']}-${module.id}` }
            casestudies={module.casestudies}
          />
        )
        default:
          break;
      }
      return true;
    })}
  </>
)

export default Modules
